import React, { FC, PropsWithChildren, useContext, useMemo } from 'react';

import { ItemsDisplayMode } from './config';
import type { ItemsDisplayModeEnumType } from './types';

type ContextType = {
  itemsDisplayMode: ItemsDisplayModeEnumType;
  closeMoreDropdown: Function;
};

const defaultValue: ContextType = {
  itemsDisplayMode: ItemsDisplayMode.IconsTitles,
  closeMoreDropdown: Function.prototype,
};

export const HeaderContext = React.createContext(defaultValue);
HeaderContext.displayName = 'HeaderContext';

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderContextProvider: FC<PropsWithChildren & ContextType> = ({
  itemsDisplayMode,
  closeMoreDropdown,
  children,
}) => {
  const value = useMemo(
    () => ({ itemsDisplayMode, closeMoreDropdown }),
    [itemsDisplayMode, closeMoreDropdown],
  );

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};
